import { BrowserRouter as Router } from "react-router-dom";
import AppFooter from "./components/shared/AppFooter";
import AppBanner from "./components/shared/AppBanner";
import { ProjectsProvider } from "./context/ProjectsContext";
import ProjectsGrid from "./components/projects/ProjectsGrid";
import TechStack from "./components/TechStack";

import "./css/App.css";

function App() {
  return (
    <Router>
      <div className=" bg-secondary-light dark:bg-primary-dark transition duration-300">
        <div className="container mx-auto">
          <div style={{ marginTop: "10vh" }}>
            <AppBanner></AppBanner>
          </div>

          <ProjectsProvider>
            <ProjectsGrid></ProjectsGrid>
          </ProjectsProvider>

          <TechStack />
        </div>

        <AppFooter />
      </div>
    </Router>
  );
}

export default App;
